import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import { getRandomness } from 'shared/random-generator'
import classNames from 'classnames'

export default function DatePicker({
    value,
    startOfWeek,
    displayFormat,
    readOnly,
    onChange,
    label,
    disabled,
    focused,
    onFocusChange,
    alwaysShowIcon,
    ...datePickerProps
}) {
    const [isFocused, setIsFocused] = React.useState(focused || false)
    const [date, setDate] = React.useState(value)
    const onDateChange = value => {
        setDate(value)
        onChange && onChange(value)
    }
    const onFocusChangeHandler = ({ focused }) => {
        setIsFocused(focused)
        onFocusChange && onFocusChange(focused)
    }

    React.useEffect(() => {
        setIsFocused(focused)
    }, [focused])

    // when value changes from props, after initial render
    React.useEffect(() => {
        setDate(value)
    }, [value])

    return (
        <div
            className={classNames('date-picker', {
                'date-picker--read-only': readOnly,
                'date-picker--always-icon': alwaysShowIcon,
            })}>
            <span className="text-small d-block text-uppercase">{label}</span>
            <SingleDatePicker
                id={getRandomness().toString()}
                disabled={disabled || readOnly}
                numberOfMonths={1}
                firstDayOfWeek={startOfWeek}
                date={date}
                onDateChange={onDateChange}
                displayFormat={displayFormat}
                focused={isFocused}
                onFocusChange={onFocusChangeHandler}
                readOnly={true}
                renderMonth={m => {
                    const months = moment.localeData().months()
                    return `${months[m.month()]} ${m.format('YYYY')}`
                }}
                {...datePickerProps}
            />
        </div>
    )
}

DatePicker.defaultProps = {
    startOfWeek: 1,
}

DatePicker.propTypes = {
    // moment object
    value: PropTypes.shape({}),
    startOfWeek: PropTypes.number,
    onChange: PropTypes.func,
    displayFormat: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    readOnly: PropTypes.bool,
    focused: PropTypes.bool,
    alwaysShowIcon: PropTypes.bool,
}
